// extracted by mini-css-extract-plugin
export default {"font-renta":"Account_font-renta__UmUwN","orangeLink":"Account_orangeLink__yvBuF"};